import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useJsApiLoader } from '@react-google-maps/api'
import ApplicationContext from './context/ApplicationContext'
import Container from './components/Container'
import { LocationDetailsTabs } from './constants'
import TranslationUtilities from './utilities/TranslationUtilities'

// Static libraries array to prevent re-renders
const libraries = ['places', 'marker']

const FittingLocationMap = props => {
    const [applicationData, setApplicationData] = useState({
        defaultLat: props.defaultLat,
        defaultLong: props.defaultLong,
        defaultZoom: props.defaultZoom,
        unitType: props.unitType,
        selectedFilterNames: props.filters,
        language: props.language,
        localizations: TranslationUtilities.getTranslations(props.language),
        queryParamLocationSet: props.queryParamLocationSet,
        filters: [],
        footer: props.footer,
        radius: props.radius,
        region: props.region,
        sort: props.sort,
        hideSort: props.hideSort,
        styling: props.styling,
        openFiltersList: false,
        locationClickZoom: 16,
        minMapZoom: 3,
        mapViewMobile: false,
        activeLocationTab: LocationDetailsTabs.Null,
        overlay: false,
        fittingProcessUrl: props.fittingProcessUrl,
        scheduleFittingUrl: props.scheduleFittingUrl,
    })

    const mapId = process.env.REACT_APP_GOOGLE_MAP_ID || ''

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY ?? '',
        libraries,
        mapIds: [mapId],
    })

    return (
        isLoaded && (
            <div className={`${applicationData.styling} ${applicationData.overlay ? 'overlay' : ''}`}>
                <ApplicationContext.Provider value={[applicationData, setApplicationData]}>
                    <Container />
                </ApplicationContext.Provider>
            </div>
        )
    )
}

FittingLocationMap.propTypes = {
    defaultLat: PropTypes.number,
    defaultLong: PropTypes.number,
    defaultZoom: PropTypes.number,
    unitType: PropTypes.string,
    queryParamLocationSet: PropTypes.object || undefined,
    filters: PropTypes.array,
    footer: PropTypes.bool,
    radius: PropTypes.number,
    region: PropTypes.string,
    sort: PropTypes.string,
    hideSort: PropTypes.bool,
    styling: PropTypes.string,
    language: PropTypes.string,
    fittingProcessUrl: PropTypes.string,
    scheduleFittingUrl: PropTypes.string,
}

export default FittingLocationMap
